/* Scope & Field: small progressive enhancements. Loaded deferred from snippets/sf-head.liquid. */

/* Read more: clamps long text to N lines at every width and adds a toggle. Without JS the full text shows.
   Re-measures when the layout crosses the 750px breakpoint, since the text column changes width there. */
class SfReadMore extends HTMLElement {
  connectedCallback() {
    this.content = this.querySelector('.sf-read-more__content');
    this.toggle = this.querySelector('.sf-read-more__toggle');
    if (!this.content || !this.toggle) return;
    this.lines = parseInt(this.dataset.lines, 10) || 4;
    this.mq = window.matchMedia('(max-width: 749px)');
    this.update = this.update.bind(this);
    this.toggle.addEventListener('click', () => {
      const open = this.toggle.getAttribute('aria-expanded') === 'true';
      this.toggle.setAttribute('aria-expanded', String(!open));
      this.classList.toggle('is-open', !open);
    });
    this.mq.addEventListener('change', this.update);
    this.update();
  }
  update() {
    this.style.setProperty('--sf-lines', this.lines);
    if (this.classList.contains('is-open')) return;
    this.classList.remove('is-short');
    this.classList.add('is-clamped');
    const clamped = this.content.scrollHeight > this.content.clientHeight + 2;
    this.classList.toggle('is-clamped', clamped);
    this.classList.toggle('is-short', !clamped);
    this.toggle.hidden = !clamped;
  }
}
if (!customElements.get('sf-read-more')) customElements.define('sf-read-more', SfReadMore);
